import {
  // endOfYesterday,
  sub,
  startOfMonth,
  subDays,
  endOfMonth,
  subMonths,
  endOfToday,
} from "date-fns";
import { TDateRangeOption } from "types/APIParameters";

export type TLabels =
  | "Current Month"
  | "Current Week"
  | "Last Month"
  | "Last 30 Days"
  | "Last 60 Days"
  | "Last 90 Days"
  | "All Time"
  | "Last 7 Days";

export interface IDateRange {
  endDate: Date;
  startDate: Date;
  key?: TDateRangeOption;
}

export interface ICommonDateRange {
  label: TLabels;
  value: IDateRange;
  key: TDateRangeOption;
}

const currentDate = new Date();

export const currentMonth = {
  endDate: endOfToday(),
  startDate: startOfMonth(currentDate),
};

export const threeDaysToToday = {
  endDate: endOfToday(),
  startDate: sub(endOfToday(), { days: 2 }),
};

export const today = {
  endDate: endOfToday(),
  startDate: currentDate,
};

export const lastWeek = {
  endDate: endOfToday(), // endOfYesterday() original value
  startDate: sub(endOfToday(), { days: 6 }),
};

export const lastMonth = {
  endDate: endOfMonth(subMonths(currentDate, 1)),
  startDate: startOfMonth(subMonths(currentDate, 1)),
};

export const lastThirtyDays = {
  endDate: endOfToday(), // endOfYesterday() original value
  startDate: subDays(endOfToday(), 29), // subDays(endOfYesterday(), 29), original value
};

export const lastSixtyDays = {
  endDate: endOfToday(), // endOfYesterday() original value
  startDate: subDays(endOfToday(), 59), // subDays(endOfYesterday(), 59), original value
};

export const lastNinetyDays = {
  endDate: endOfToday(), // endOfYesterday() original value
  startDate: subDays(endOfToday(), 89), // subDays(endOfYesterday(), 89), original value
};

export const allTime = {
  endDate: endOfToday(),
  startDate: new Date("2021-01-01"),
}

const commonDateRanges: ICommonDateRange[] = [
  {
    label: "Last 7 Days",
    value: lastWeek,
    key: "last_7_days",
  },
  {
    label: "Last Month",
    value: lastMonth,
    key: "last_month",
  },
  {
    label: "Last 30 Days",
    value: lastThirtyDays,
    key: "last_30_days",
  },
  {
    label: "Last 60 Days",
    value: lastSixtyDays,
    key: "last_60_days",
  },
  {
    label: "Last 90 Days",
    value: lastNinetyDays,
    key: "last_90_days",        
  },
];

export const graphDateRange: ICommonDateRange[] = [
  {
    label: "Current Month",
    value: currentMonth,
    key: "current_month",
  },
  {
    label: "Last Month",
    value: lastMonth,
    key: "last_month",
  },
  {
    label: "Last 60 Days",
    value: lastSixtyDays,
    key: "last_60_days",
  },
  {
    label: "Last 90 Days",
    value: lastNinetyDays,
    key: "last_90_days",
  },
];

export default commonDateRanges;

export const commonDateRangesV2: ICommonDateRange[] = [
  {
    label: "Last 7 Days",
    value: lastWeek,
    key: "last_7_days",
  },
  {
    label: "Last Month",
    value: lastMonth,
    key: "last_month",
  },
  {
    label: "All Time",
    value: allTime,
    key: "all_time",
  }
];

export const graphDateRangeV2: ICommonDateRange[] = [
  {
    label: "Current Month",
    value: currentMonth,
    key: "current_month",
  },
  {
    label: "Last Month",
    value: lastMonth,
    key: "last_month",
  },
  {
    label: "All Time",
    value: allTime,
    key: "all_time",
  }
];


export const getDateRangeByKey = (key: TDateRangeOption): IDateRange => {
  switch (key) {
    case "current_month":
      return currentMonth;
    case "last_month":
      return lastMonth;
    case "last_30_days":
      return lastThirtyDays;
    case "last_60_days":
      return lastSixtyDays;
    case "last_90_days":
      return lastNinetyDays;
    case "all_time":
      return allTime;
    case "last_7_days":
      return lastWeek;
    default:
      return allTime;
  }
};
